/* import __COLOCATED_TEMPLATE__ from './tour-step-failure-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();